import { initPopover } from "./mypage-modules/popover.js";
import { initModalAdd } from "./mypage-modules/modal-add.js";
import { initModalDelete } from "./mypage-modules/modal-delete.js";
import { initCommonModals } from "./mypage-modules/modal-mycar.js";
import { initCouponModals } from "./mypage-modules/modal-coupon.js";
import { initReserveFlowInsideModal } from "./mypage-modules/modal-reserve.js";

document.addEventListener("DOMContentLoaded", () => {
  // initPopover();
  initModalAdd();
  initModalDelete();
  initCommonModals();
  initCouponModals();
  initReserveFlowInsideModal();
});
